/* Takumi™ — kolekcijos puslapio elgsena.
   Self-contained: shares nothing with the product-page runtimes, so this kit
   can be uploaded or removed on its own. Installs once however many sections
   render the script tag. */
(function () {
  'use strict';
  if (window.TKC) return;
  var TKC = (window.TKC = {});
  TKC.version = '2026-10-09-collection';

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ----------------------------------------------- room for a floating header
     The store's header is drawn over the top of the first section, which
     buries the collection's name underneath it.

     An earlier version here looked the header up by selector and asked whether
     it was positioned `absolute` or `fixed`. On this store it is neither, so
     nothing was allowed for and the name stayed hidden. Looking for a header,
     by name or by how it is positioned, is a guess about how a theme is built.

     This asks the browser what is actually painted at the section's own top
     edge. Whatever answers, and however it got there, its bottom is where the
     section has to begin. The same method is used on the product pages, where
     it measured 83px on a desktop and 75px on a phone — which is also why a
     number typed into the stylesheet would have been wrong on one of them. */
  var measured = false;

  function clearFloatingHeader() {
    var el = document.querySelector('[data-tkc-top]');
    if (!el) return;
    /* Only a measurement taken at the top of the page is trustworthy: further
       down the header has either scrolled away or re-pinned itself, and the
       probe would read whatever content happens to be under it.
       Nothing is cleared before bailing out — the value is only ever replaced
       by a newer, valid one, so a resize fired mid-page cannot throw away a
       good reading. */
    if ((window.pageYOffset || document.documentElement.scrollTop || 0) > 4) return;
    var r0 = el.getBoundingClientRect();
    if (r0.top < 0 || r0.top >= window.innerHeight) return;
    var x = Math.round(r0.left + Math.min(r0.width / 2, 200));
    /* Bars can be stacked: an announcement strip with the header floating
       below it. Probing once answers with the strip alone and the header is
       still left covering the heading, so each answer is probed again just
       under its own bottom edge and the allowance grows until nothing more is
       in the way. The counter is only there so a pathological page cannot spin
       here. */
    var bottom = r0.top, guard = 0;
    while (guard++ < 5) {
      var probeY = Math.round(bottom) + 2;
      if (probeY >= window.innerHeight) break;
      var node = document.elementFromPoint(x, probeY);
      var found = 0;
      while (node && node !== document.body && node !== document.documentElement) {
        /* Skip anything wrapping this section: it is not covering us. */
        if (!node.contains(el)) {
          var cr = node.getBoundingClientRect();
          /* It has to straddle the point being probed to be covering it.
             Without this the walk accepts any ancestor at all. */
          if (cr.height > 0 && cr.height <= 400 &&
              cr.top <= probeY && cr.bottom > probeY && cr.bottom > found) {
            found = cr.bottom;
          }
        }
        node = node.parentElement;
      }
      if (found <= bottom + 0.5) break;
      bottom = found;
    }
    var overlap = Math.max(0, Math.round(bottom - r0.top));
    /* No header is taller than this; anything bigger is a misread. */
    if (overlap > 400) return;
    document.documentElement.style.setProperty('--tkc-head', overlap + 'px');
    measured = true;
  }

  /* A header can settle late: web fonts change its height, or a script builds
     it after the page is parsed. A few spaced passes catch that and then stop.
     They are safe to repeat — each either replaces the value with a newer valid
     measurement or leaves it alone. */
  function watchHeader() {
    clearFloatingHeader();
    [300, 1000, 2500].forEach(function (ms) { setTimeout(clearFloatingHeader, ms); });
    window.addEventListener('load', function () { setTimeout(clearFloatingHeader, 200); });

    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      measured = false;
      clearFloatingHeader();
    });
    window.addEventListener('orientationchange', function () {
      setTimeout(clearFloatingHeader, 250);
    });

    /* Every pass above refuses to measure unless the page is at the top, which
       is correct — lower down the header has moved and the reading would be
       wrong. But a page can open already scrolled: the browser restoring a
       position, or a back navigation. Then no pass ever succeeds and the name
       is tucked under the header again on returning to the top. This keeps
       watching until one measurement lands, then stops listening. */
    var pending;
    function measureWhenAtTop() {
      if (measured) { window.removeEventListener('scroll', measureWhenAtTop); return; }
      if (pending) return;
      pending = requestAnimationFrame(function () {
        pending = 0;
        clearFloatingHeader();
        if (measured) window.removeEventListener('scroll', measureWhenAtTop);
      });
    }
    window.addEventListener('scroll', measureWhenAtTop, { passive: true });

    /* Coming back through the browser's history restores the page from cache
       without running any of the above again. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { measured = false; clearFloatingHeader(); }
    });
  }

  /* ------------------------------------------------------- kolekcijų juosta
     The link for the collection being viewed has to be on screen, and on a
     phone it is often the fifth of ten. `scrollIntoView` would do it, but it
     walks up every scrollable ancestor and drags the page down with it — the
     visitor lands halfway through the section. Setting `scrollLeft` moves the
     one strip and nothing else. Nothing happens when the row already fits. */
  function bindNav() {
    $$('[data-tkc-nav]').forEach(function (nav) {
      var here = nav.querySelector('[aria-current="page"]');
      if (!here) return;
      if (nav.scrollWidth <= nav.clientWidth + 1) return;
      var left = here.offsetLeft - nav.offsetLeft - (nav.clientWidth - here.offsetWidth) / 2;
      var max = nav.scrollWidth - nav.clientWidth;
      nav.scrollLeft = Math.max(0, Math.min(left, max));
    });
  }

  /* ------------------------------------------------------------ rūšiavimas
     The control is a real GET form, so it works with scripting switched off —
     the visitor picks and presses the button. Here the button is taken away and
     the form submits on change, which is what everyone expects. `data-tkc-live`
     is what hides the button and is set from here rather than in the
     stylesheet, so the button never disappears for someone who needs it. */
  function bindSort() {
    $$('[data-tkc-sort]').forEach(function (form) {
      var sel = form.querySelector('select[name="sort_by"]');
      if (!sel) return;
      form.setAttribute('data-tkc-live', 'true');
      sel.addEventListener('change', function () {
        /* Sorting starts the list again: staying on page 4 of the old order
           would land the visitor in the middle of the new one. */
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });
  }

  function init() {
    watchHeader();
    bindNav();
    bindSort();
    /* The theme editor rebuilds one section at a time without reloading. */
    document.addEventListener('shopify:section:load', function () {
      measured = false;
      clearFloatingHeader();
      bindNav();
      bindSort();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  TKC.measureHeader = clearFloatingHeader;
})();
